import { createContext } from 'react';
import { createContextualCan, useAbility as useAbilityContext } from '@casl/react';
import { ability } from './ability';

export const AbilityContext = createContext(ability);
export const Can = createContextualCan(AbilityContext.Consumer);

export const useAbility = () => useAbilityContext(AbilityContext);
